/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import ProfileAvatar from '../../../../components/ProfileAvatar';
import RouteNames from '../../../RouteNames';
import ProfileModel from '../../../../../models/ProfileModel';
import FlexRow from '../../../../components/FlexRow';
import Card, { CardSection } from '../../../../components/card/Card';
import AppUtils from '../../../../../utilities/AppUtils';
import { LocalText, LocalizedText } from '../../../../../utilities/localizedUtil';
import SquareImageIcon from '../../../../components/SquareImageIcon';

import { useUIState } from '../../../../hooks/useUIState';
import { useActiveUser } from '../../../../hooks/useUser';
import { useNavigate } from '../../../../hooks/useNavigate';

interface Props {
  notification: {
    type: string;
    survey_reminder: {
      active_at: string;
      group: {
        id: number;
        name: LocalizedText;
        logo: string;
        theme: {
          base_rgba: any;
        }
      };
      profile: {
        color_theme_id: number;
      };
      survey: {
        id: number;
      };
      survey_definition: {
        name: string;
      };
    }
  };
}

const SurveyReminderNotification = (props: Props) => {
  const { notification } = props;
  const cssColor = AppUtils.cssColor(notification.survey_reminder.group.theme.base_rgba);

  const [{ user }] = useActiveUser();
  const [, uiActions] = useUIState();
  const [, navActions] = useNavigate();

  const profile = new ProfileModel(notification.survey_reminder.profile);
  const profileId = profile.data.id;
  const isMainProfile = profileId === user.profile_id;
  const group: any = notification.survey_reminder.group;
  const groupId = notification.survey_reminder.group.id;
  const surveyId = notification.survey_reminder.survey.id;

  return (
    <Card>
      <CardSection hasBorder>
        <FlexRow className="font-body"style={{ width: '100%' }}>
          <div>
            {
              isMainProfile ? (
                <FormattedMessage id="notification.surveyReminder.user.message" />
              ) : (
                <FormattedMessage id="notification.surveyReminder.notUser.message" values={{ string1: profile.greetingName(), string2: 'hello' }} />
              )
            }
            {notification.survey_reminder.survey_definition.name}
          </div>


          <div style={{ marginLeft: 24 }}>
            <ProfileAvatar profile={profile} size={48} fontSize={15} />
          </div>
        </FlexRow>
        <div className="font-caption-1 font-color-gsMedDark" style={{ marginTop: 12, marginRight: 72 }}>
          <LocalText text={group.name} />
        </div>
      </CardSection>

      <CardSection hasBorder={false} isBottomCard className="bkgd-color-csAppBGgray">
        <button
          onClick={() => {
            uiActions.setActiveProfile(profileId);
            navActions.goTo(RouteNames.surveyResume(groupId, surveyId));
          }}
          style={{ width: '100%', padding: 0 }}
        >
          <FlexRow className="font-body font-color-profile-accent">
            <FormattedMessage id="notification.surveyReminder.goTo.button.label" />
            <div style={{ paddingRight: 8 }}>
              <SquareImageIcon
                src={group.logo}
                size={32}
                backgroundColor={cssColor}
                placeholderText={group.name.default ? group.name.default[0] : ''}
                altText="logo"
              />
            </div>
          </FlexRow>
        </button>
      </CardSection>
    </Card>
  );
};

export default SurveyReminderNotification;
